import axios from 'axios';

import { ModificationApiError } from './modificationApi';
import type { UploadProgress } from './modificationApi';

// The browser's PUT of the modified video to the single-use link the gateway
// signed (E4). The pattern of api/vpm/liveUploadApiClient.ts, copied rather than
// imported so the upload wizard's client is not touched.
//
// WHAT MUST HOLD, AND WHY.
// - Bare axios, NEVER the shared apiClient: apiClient adds the Firebase ID
//   token as Authorization and X-Firebase-ID-Token, and the bucket must never
//   receive it.
// - Exactly the headers the gateway signed into the URL (Content-Type,
//   x-goog-if-generation-match, x-goog-content-length-range), copied so nothing
//   can be added to them after signing.
// - withCredentials false, so no cookie goes either.
// - The body is the File as-is: transformRequest passes it through untouched.
// - Only an https link (review of 20 Oct): the gateway signs one, and anything
//   else is refused before a byte is sent.
export const putToSignedUrl = async (
  uploadUrl: string,
  file: File,
  requiredHeaders: Record<string, string>,
  onProgress?: UploadProgress,
  signal?: AbortSignal
): Promise<void> => {
  if (!/^https:\/\//i.test(uploadUrl)) {
    throw new ModificationApiError('The upload link is not an https link.', { kind: 'unknown' });
  }
  await axios.put(uploadUrl, file, {
    headers: { ...requiredHeaders },
    withCredentials: false,
    transformRequest: [(data: unknown) => data],
    signal,
    onUploadProgress: (event) => {
      if (onProgress && event.total) {
        onProgress(event.loaded / event.total);
      }
    },
  });
};
